import React, { useEffect, useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Tooltip, Upload } from 'antd';
import "../layout/layouts-styles.css";
import { ModalComponent } from "@comps/components"


const BaseUploadFile = (props) => {

  var fileData=props.fileList ? props.fileList : [];

  const [fileList, setFileList] = useState(props.fileList ? props.fileList : [])
  const acceptType=props.accept?props.accept:'.pdf,.jpg,.png,.jpeg';
  //============uploading file============
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const handleCancel = () => setPreviewOpen(false);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    fileData=newFileList;
    if (typeof props.setFileList === 'function') {
      props.setFileList(newFileList)
    }
    if (typeof props.onChange === 'function') {
      props.onChange({ fileList: newFileList })
    }
  };

  const onPreview = async (file) => {
    const extension = String(file.extension || file.name?.split('.').pop() || '').toLowerCase();
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension) || String(file.type || '').startsWith('image/');
    const isPdf = extension === 'pdf' || file.type === 'application/pdf';

    if (file.url && (!isImage || isPdf)) {
      window.open(file.url, '_blank');
      return;
    }

    if (isPdf && file.originFileObj) {
      const blobUrl = URL.createObjectURL(file.originFileObj);
      window.open(blobUrl, '_blank');
      return;
    }

    if (!isImage && file.originFileObj) {
      window.open(URL.createObjectURL(file.originFileObj), '_blank');
      return;
    }

    if (!file.url && !file.preview && file.originFileObj) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url?.substring(file.url.lastIndexOf('/') + 1));
  };
  // ------------------------------------

  return (
    <>
      <Upload
        { ...props }
        listType="picture"
        accept={acceptType}
        fileList={ fileData }
        onChange={ onChange }
        onPreview={ onPreview }
        //defaultFileList={ [...fileList] }
        //className="upload-list-inline"
        multiple={ false }
        beforeUpload={ (file) => {
          return false;
        } }
        style={{cursor:"pointer"}}
      >
        { fileData.length === 1 ? null : <Tooltip title="Drag & Drop or Click to Select file"><Button icon={ <UploadOutlined /> }>Upload</Button> </Tooltip>}
      </Upload>

      <ModalComponent width={ 1000 } open={ previewOpen } title={ previewTitle } footer={ null } onCancel={ handleCancel }>
        <img
          alt="example"
          style={ {
            width: '100%',
          } }
          src={ previewImage }
        />
      </ModalComponent>
    </>
  )
}


export default BaseUploadFile;
